import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import {
  BatteryPrediction,
  BatteryPredictionStatus,
} from '../../models/battery-prediction';

type BatteryPredictionPresentation = {
  badgeClass: string;
  labelKey: string;
  tooltipKey?: string;
};

const PRESENTATION_BY_STATUS: Record<
  BatteryPredictionStatus,
  { badgeClass: string; tooltipKey?: string }
> = {
  NO_DATA: {
    badgeClass: 'text-bg-secondary',
  },
  NOT_ENOUGH_DATA: {
    badgeClass: 'text-bg-warning',
    tooltipKey: 'batteryPrediction.tooltips.NOT_ENOUGH_DATA',
  },
  OK: {
    badgeClass: 'text-bg-success',
  },
  REPLACE_SOON: {
    badgeClass: 'text-bg-warning',
  },
  REPLACE_NOW: {
    badgeClass: 'text-bg-danger',
  },
};

@Component({
  standalone: true,
  selector: 'app-battery-prediction-badge',
  imports: [TranslatePipe, TooltipModule],
  template: `
    @if (presentation(); as presentation) {
      <span
        class="badge rounded-pill"
        [class]="presentation.badgeClass"
        [pTooltip]="
          presentation.tooltipKey
            ? (presentation.tooltipKey | translate)
            : undefined
        "
        placement="bottom"
        container="body"
      >
        {{ presentation.labelKey | translate }}
      </span>
    } @else {
      -
    }
  `,
})
export class BatteryPredictionBadgeComponent {
  readonly prediction = input<BatteryPrediction | undefined>();

  protected readonly presentation = computed<
    BatteryPredictionPresentation | undefined
  >(() => {
    const prediction = this.prediction();
    if (!prediction?.status) {
      return undefined;
    }

    const presentation = PRESENTATION_BY_STATUS[prediction.status];
    if (!presentation) {
      return undefined;
    }

    return {
      badgeClass: presentation.badgeClass,
      labelKey: `batteryPrediction.statusValues.${prediction.status}`,
      tooltipKey: presentation.tooltipKey,
    };
  });
}
